import { pdfAdminArrList, pdfStudentArrList, pdfTeacherArrList } from 'assets/constant';
import BreadCrumb from 'components/shared/BreadCrumb';
import { Sidebar } from 'components/shared/sidebar';
import { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useRecoilState } from 'recoil';
import { useUserState } from 'recoil/useUserState';
import { handleOpenManual } from 'util/supporting/menual';

export const Manual = () => {
  const [key, setKey] = useState('student');
  const [user, setUser] = useRecoilState(useUserState);

  return (
    <>
      <Sidebar />
      <main id='main' className='main'>
        <BreadCrumb home={'/manual'} sublink={'/manual'} title={'매뉴얼 (Manual)'}>
          &nbsp;/ 매뉴얼
        </BreadCrumb>

        <div className='card py-20 px-1'>
          <Tabs
            activeKey={key}
            onSelect={(k) => setKey(k)}
            defaultActiveKey='home'
            transition={false}
            id='noanim-tab-example'
            className='mb-3'
          >
            {(user.role === 'STUDENT' || user.role === 'TEACHER' || user.role === 'ADMIN') && (
              <Tab eventKey='student' title='학습자'>
                <div className='pb-3'>
                  <ul className='row px-5 gapY-4'>
                    {pdfStudentArrList.map((item) => (
                      <>
                        <li
                          className='col-3 d-flex flex-column justify-content-center align-items-center my-4'
                          key={item}
                        >
                          <div className='border rounded max-w-270'>
                            <div className='d-flex justify-content-center'>
                              <img src='/assets/img/manual/img.jpg' alt='이미지' />
                            </div>
                            <div className='px-3 text-start'>
                              <h3 className='my-2 fz-18 fw-bold'>{item.name}</h3>
                              <p className='my-1'>업데이트: {item.createAt}</p>
                              <div>
                                <p className='py-2 px-0 text_dat text-truncate d-block text_dat text-start'>
                                  {item.subName}
                                </p>
                              </div>
                              <button
                                onClick={() => handleOpenManual(item.path, 'student')}
                                className='badge link-badge border fz-14 mt-2 mb-4 bg-second'
                              >
                                매뉴얼 보기
                              </button>
                              {!item.path.includes('https') && (
                                <a
                                  href={`/assets/pdf/student/${item.path}`}
                                  download={item.path}
                                  className='badge link-badge border fz-14 mt-2 mb-4 bg-primary ml-5'
                                >
                                  다운로드
                                </a>
                              )}
                            </div>
                          </div>
                        </li>
                      </>
                    ))}
                  </ul>
                </div>
              </Tab>
            )}
            {(user.role === 'TEACHER' || user.role === 'ADMIN') && (
              <Tab eventKey='teacher' title='교수자'>
                <div className='pb-3'>
                  <ul className='row px-5 gapY-4'>
                    {pdfTeacherArrList.map((item) => (
                      <li
                        className='col-3 d-flex flex-column justify-content-center align-items-center my-4'
                        key={item}
                      >
                        <div className='border rounded max-w-270'>
                          <div className='d-flex justify-content-center'>
                            <img src='/assets/img/manual/img.jpg' alt='이미지' />
                          </div>
                          <div className='px-3 text-start'>
                            <h3 className='my-2 fz-18 fw-bold'>{item.name}</h3>
                            <p className='my-1'>업데이트: {item.createAt}</p>
                            <div>
                              <p className='py-2 px-0 text_dat text-truncate d-block text_dat text-start'>
                                {item.subName}
                              </p>
                            </div>
                            <button
                              onClick={() => handleOpenManual(item.path, 'teacher')}
                              className='badge link-badge border fz-14 mt-2 mb-4 bg-second'
                            >
                              매뉴얼 보기
                            </button>
                            <a
                              href={`/assets/pdf/teacher/${item.path}`}
                              download={item.path}
                              className='badge link-badge border fz-14 mt-2 mb-4 bg-primary ml-5'
                            >
                              다운로드
                            </a>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </Tab>
            )}
            {user.role === 'ADMIN' && (
              <Tab eventKey='admin' title='관리자'>
                <div className='pb-3'>
                  <ul className='row px-5'>
                    {pdfAdminArrList.map((item) => (
                      <li
                        className='col-3 d-flex flex-column justify-content-center align-items-center my-4'
                        key={item}
                      >
                        <div className='border rounded max-w-270'>
                          <div className='d-flex justify-content-center'>
                            <img src='/assets/img/manual/img.jpg' alt='이미지' />
                          </div>
                          <div className='px-3 text-start'>
                            <h3 className='my-2 fz-18 fw-bold'>{item.name}</h3>
                            <p className='my-1'>업데이트: {item.createAt}</p>
                            <div>
                              <p className='py-2 px-0 text_dat text-truncate d-block text_dat text-start'>
                                {item.subName}
                              </p>
                            </div>
                            <button
                              onClick={() => handleOpenManual(item.path, 'admin')}
                              className='badge link-badge border fz-14 mt-2 mb-4 bg-second'
                            >
                              매뉴얼 보기
                            </button>
                            <a
                              href={`/assets/pdf/admin/${item.path}`}
                              download={item.path}
                              className='badge link-badge border fz-14 mt-2 mb-4 bg-primary ml-5'
                            >
                              다운로드
                            </a>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </Tab>
            )}
          </Tabs>
        </div>
      </main>
    </>
  );
};
